// Hardcoded for now - thes represent landing pages showing certain collections, e.g. "Runs" and "Hikes"

export const collectionIDsForHandle = (handle: string) => {
  return [
    "c53fbb3c-1be5-4e1e-a091-90078108ced2",
    "f5a93fe0-6900-4334-8b48-82ea4af8c81a",
  ];
};
